var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 3.33333,
    height: 2,
    rx: 1,
    fill: "#1C384A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 5.44772 11.4477 5 12 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7H12C11.4477 7 11 6.55228 11 6Z",
    fill: "#1C384A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32328 5.0376L12.0038 1.19064C12.9168 0.827825 13.7509 1.86136 13.2035 2.67715L11.3715 5.40726C11.1465 5.74249 11.1452 6.1801 11.3681 6.51667L13.2244 9.31927C13.7665 10.1377 12.9279 11.1657 12.0172 10.7991L2.31911 6.89455C1.48172 6.55741 1.48438 5.37097 2.32328 5.0376Z",
    fill: "#1C384A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e406136b3d86ae6cbfc7fd7f5f1831c3.svg";
export { ForwardRef as ReactComponent };